import { useIsMobile } from 'pricing-pages-ui-components/hooks/useMedia';
import { CardSection, CardWrapper } from 'foundations-components/transitional/components/Card';
import { View } from 'foundations-components/components/View';
import HubSpotCreditsFeatures from '../../../components/key-features/HubSpotCreditsFeatures';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
// TODO: Still buidling and will use unlockHubSpotCreditsSkuIds and title in the future
export const UnlockAIContentLayout = ({
  subscreen,
  title
}) => {
  const isMobile = useIsMobile();
  if (isMobile) {
    return /*#__PURE__*/_jsxs(View, {
      backgroundColor: "fill-surface-default",
      padding: "0",
      children: [title, /*#__PURE__*/_jsx(_Fragment, {
        children: "HubSpotCreditsTilesContainer"
      }), /*#__PURE__*/_jsx(HubSpotCreditsFeatures, {
        subscreen: subscreen
      })]
    });
  }
  return /*#__PURE__*/_jsx(CardWrapper, {
    padding: "1300",
    borderRadius: "300",
    borderWidth: "100",
    blockSize: "100%",
    marginBlock: "0",
    children: /*#__PURE__*/_jsxs(CardSection, {
      padding: "0",
      children: [title, /*#__PURE__*/_jsx(_Fragment, {
        children: "HubSpotCreditsTilesContainer"
      }), /*#__PURE__*/_jsx(HubSpotCreditsFeatures, {
        subscreen: subscreen
      })]
    })
  });
};